import { useCartLineItems, useCartTotalAmount } from '@ecomm/data-cart'
import { useLocale } from '@ecomm/data-hooks'

import { isString } from '@simplisafe/ewok'
import { useLiveChatTrackOrder } from '.'

export function useLiveChatTrackOrderJotai(orderId: string) {
  const locale = useLocale()

  const lineItems = useCartLineItems()
  const total = useCartTotalAmount()

  const sensors = lineItems
    .filter(item => item.productType === 'sensor')
    .map(item => item.name[locale])
    .filter(isString)

  const packageSensors = lineItems
    .flatMap(item => item.packageItems)
    .filter(item => item.productType === 'sensor')
    .map(item => item.name[locale])
    .filter(isString)

  useLiveChatTrackOrder(orderId, total, [...sensors, ...packageSensors])
}
